<!-- *ngIf="!(sideNavigatorService.hideSideNav$ | async) || docked" -->
<div
  *ngIf="!isLoginRoute"
  id="sidebar"
  [class.expanded]="!(sideNavigatorService.hideSideNav$ | async)"
  [class.collapsed]="isDesktop && (sidebarCollapseService.collapsed$ | async)"
>
  <div id="close-button" *ngIf="!docked">
    <img
      src="../../../assets/redesign/close-icon.svg"
      alt="close icon"
      (click)="sideNavigatorService.toggleSideNavigator()"
    />
  </div>
  <button
    id="collapse-button"
    *ngIf="isDesktop"
    type="button"
    aria-label="Collapse sidebar"
    title="Collapse sidebar"
    (click)="sidebarCollapseService.collapse()"
  >
    <mat-icon>chevron_left</mat-icon>
  </button>
  <div id="toptab" *ngIf="!isDesktop">
    <div class="spacer"></div>
    <div class="circle">
      <img
        src="../../../assets/redesign/person-menu-icon.svg"
        alt="icon"
        class="circle-icon"
      />
    </div>
  </div>
  <div id="desktop-toptab" *ngIf="isDesktop">
    <img src="/assets/redesign/login/login_mn_title.svg" />
  </div>
  <div id="sidebar-title">
    <span
      >{{ (userInfo$ | async)?.firstname }}
      {{ (userInfo$ | async)?.lastname }}</span
    >
    <ng-container *ngIf="activeOrgService.orgs$ | async as switcherData">
      <span
        class="org-name"
        [class.org-switcher-trigger]="hasMultipleOrgOptions(switcherData)"
        [matMenuTriggerFor]="
          hasMultipleOrgOptions(switcherData) ? orgMenu : null
        "
        >{{ (org$ | async)?.name
        }}<mat-icon
          *ngIf="hasMultipleOrgOptions(switcherData)"
          class="org-switcher-caret"
          aria-hidden="true"
          >expand_more</mat-icon
        ></span
      >
      <mat-menu
        #orgMenu="matMenu"
        (opened)="onOrgMenuOpened()"
        panelClass="org-switcher-panel"
        xPosition="before"
      >
        <div class="org-switcher-label">Your Organizations</div>
        <button
          mat-menu-item
          *ngFor="let org of switcherData.current_account.orgs"
          class="org-switcher-item"
          [class.org-switcher-item-active]="org.active"
          [disabled]="org.active || switchingOrg"
          (click)="switchToOrganization(org)"
        >
          <mat-icon class="org-switcher-item-icon">business</mat-icon>
          <span class="org-switcher-item-name">{{
            org.organization_name || org.organization_id
          }}</span>
          <mat-icon
            *ngIf="org.active"
            class="org-switcher-item-check"
            aria-hidden="false"
            aria-label="Current organization"
            >check_circle</mat-icon
          >
        </button>

        <ng-container *ngIf="switcherData.linked_accounts.length > 0">
          <mat-divider class="org-switcher-divider"></mat-divider>
          <div class="org-switcher-label">Linked Accounts</div>
          <ng-container *ngFor="let account of switcherData.linked_accounts">
            <button
              mat-menu-item
              *ngFor="let org of account.orgs"
              class="org-switcher-item org-switcher-item-linked"
              [disabled]="switchingOrg"
              (click)="
                switchToLinkedAccount(
                  account.account_id,
                  org.organization_name || org.organization_id
                )
              "
            >
              <mat-icon class="org-switcher-item-icon">swap_horiz</mat-icon>
              <span class="org-switcher-item-text">
                <span class="org-switcher-item-name">{{
                  org.organization_name || org.organization_id
                }}</span>
                <span class="org-switcher-item-email">{{ account.email }}</span>
              </span>
            </button>
          </ng-container>
        </ng-container>
      </mat-menu>
    </ng-container>
    <span *ngIf="!(activeOrgService.orgs$ | async)" class="org-name">{{
      (org$ | async)?.name
    }}</span>
  </div>
  <div class="sidebar-separator"></div>
  <div id="sidebar-body">
    <div id="sidebar-content">
      <div
        [ngClass]="{ 'selected-link-content': currentFeature && '/home' ===
        currentFeature.defaultPath, 'link-content': !currentFeature || '/home'
        !== currentFeature.defaultPath, }"
        (click)="navigateToHome()"
        clickable
      >
        <img
          src="../../../assets/redesign/home-sidebar-icon.svg"
          alt="home icon"
        />
        <span>Home</span>
      </div>
      <div
        *ngFor="let feature of filterFeaturesForScreenSize()"
        class="link-container"
      >
        <ngContainer
          class="feature-link-content"
          *ngIf="
            currentFeature && feature.defaultPath === currentFeature.defaultPath
          "
        >
          <div
            [ngClass]="{
              'selected-link-content':
                currentFeature &&
                feature.defaultPath === currentFeature.defaultPath,
              'link-content':
                !currentFeature ||
                feature.defaultPath !== currentFeature.defaultPath,
            }"
            (click)="
              navigateToFeature(
                feature.feature_id,
                feature.defaultPath,
                feature.defaultRoute
              )
            "
            clickable
          >
            <img
              class="feature-icon"
              [src]="getIcon(feature) | safeUrl"
              alt="{{ feature.homeName }}"
              (error)="onImageError()"
            />
            <span>{{ feature.homeName }}</span>
            <mat-icon
              *ngIf="feature.offlineUnsupported"
              class="offline-unsupported-icon"
              title="May not work while offline"
              >cloud_off</mat-icon
            >
          </div>
          <div
            class="sub-feature-parent-container"
            *ngIf="feature.footerIcons.length > 0"
          >
            <div
              *ngFor="let subFeature of feature.footerIcons; let last = last"
              class="sub-feature-container"
              (click)="
                navigateToFeature(
                  feature.feature_id,
                  feature.defaultPath,
                  subFeature.path
                )
              "
              clickable
            >
              <div class="bullet-container">
                <div class="bullet"></div>
                <div *ngIf="!last" class="hash-line"></div>
              </div>
              <span
                [ngClass]="{
                'sub-menu-item': !endsWithRoute(subFeature.path),
                'selected-sub-menu-item': endsWithRoute(subFeature.path),
              }"
                >{{ subFeature.name }}</span
              >
            </div>
          </div>
        </ngContainer>
        <ngContainer
          class="feature-link-content"
          *ngIf="
            !currentFeature ||
            feature.defaultPath !== currentFeature.defaultPath
          "
        >
          <div
            [ngClass]="{
              'selected-link-content':
                currentFeature &&
                feature.defaultPath === currentFeature.defaultPath,
              'link-content':
                !currentFeature ||
                feature.defaultPath !== currentFeature.defaultPath,
            }"
            (click)="
              navigateToFeature(
                feature.feature_id,
                feature.defaultPath,
                feature.defaultRoute
              )
            "
            clickable
          >
            <img
              [src]="getIcon(feature) | safeUrl"
              alt="{{ feature.homeName }}"
              (error)="onImageError()"
            />
            <span>{{ feature.homeName }}</span>
            <mat-icon
              *ngIf="feature.offlineUnsupported"
              class="offline-unsupported-icon"
              title="May not work while offline"
              >cloud_off</mat-icon
            >
          </div>
        </ngContainer>
      </div>
      <div class="link-content" (click)="hideAndLogout()" clickable>
        <img
          src="../../../assets/redesign/logout-sidebar-icon.svg"
          alt="logout icon"
        />
        <span>Logout</span>
      </div>
      <div class="content-buffer"></div>
    </div>
  </div>
  <div id="sidebar-footer"></div>
</div>

<button
  id="sidebar-reopen-tab"
  *ngIf="isDesktop && !isLoginRoute"
  type="button"
  aria-label="Open sidebar"
  title="Open sidebar"
  [class.visible]="sidebarCollapseService.collapsed$ | async"
  (click)="sidebarCollapseService.expand()"
>
  <mat-icon>chevron_right</mat-icon>
</button>

<div class="org-switch-overlay" *ngIf="switchingOrg">
  <div class="org-switch-overlay-card">
    <div class="org-switch-spinner"></div>
    <div class="org-switch-overlay-title">Switching organization</div>
    <div class="org-switch-overlay-subtitle">
      Clearing out your current workspace and loading
      {{
        switchTargetOrgName
          ? "everything for " + switchTargetOrgName
          : "your new organization"
      }}...
    </div>
  </div>
</div>

<!-- <nav
  id="sidebar"
  class="navbar-dark bg-dark"
  [ngClass]="{ hidden: sideNavigatorService.hideSideNav }"
> -->
<!-- <div
    class="paddingLT"
    *ngIf="
      functionalityService.includeAuthentication().toLowerCase() === 'true' &&
      (auth.isLoggedIn() | async)
    "
  >
    <span>Hello {{ userFirstName }}</span>
  </div>
  <div
    class="paddingLT"
    *ngIf="
      functionalityService.includeAuthentication().toLowerCase() === 'true' &&
      !(auth.isLoggedIn() | async)
    "
  >
    <span>You are not logged in</span>
  </div> -->
<!-- <ul class="navbar-nav">
    <li class="nav-item active">
      <a class="nav-link" [routerLink]="['/home']">Home</a>
    </li>
    <li class="nav-item active">
      <a class="nav-link" [routerLink]="['/about']">About Us</a>
    </li>
    <li class="nav-item active">
      <a class="nav-link" [routerLink]="['/support']">Contact Us</a>
    </li>
    <li class="nav-item active">
      <a class="nav-link" [routerLink]="['/disclaimer']">Disclaimer</a>
    </li>
    <li class="nav-item active">
      <a class="nav-link" [routerLink]="['/release-notes']">Release Notes</a>
    </li>
    <li class="nav-item active">
      <a class="nav-link" [routerLink]="['/version']">Version</a>
    </li>
    <li class="nav-item active">
      <a class="nav-link" [routerLink]="['/push-support']">Push Support</a>
    </li>
    <li class="nav-item active">
      <a class="nav-link" [routerLink]="['/react-native', 'dispatch']"
        >Dispatch</a
      >
    </li> -->
<!-- <li
      class="nav-item active"
      *ngIf="
        functionalityService.includeAuthentication().toLowerCase() === 'true' &&
        (auth.isLoggedIn() | async)
      "
    >
      <app-logout></app-logout>
    </li>
    <li
      class="nav-item active"
      *ngIf="
        functionalityService.includeAuthentication().toLowerCase() === 'true' &&
        !(auth.isLoggedIn() | async)
      "
    >
      <app-login></app-login>
    </li> -->
<!-- </ul>
</nav> -->
